<template>
  <div class="title">
    <div class="top">
      <div class="left">{{ title }}</div>
      <div class="center">
        <el-input
          v-if="showSearch"
          clearable
          v-model="content"
          placeholder="搜索"
          @change="(val) => $emit('handleChange', val)"
        >
          <i class="el-icon-search el-input__icon" slot="suffix"> </i>
        </el-input>
      </div>
      <div class="right">
        <slot name="control"></slot>
      </div>
    </div>
    <div class="bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleControl",
  props: {
    title: {
      type: String,
      required: true,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      content: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  background-color: white;
  border-radius: 15px;
  box-sizing: border-box;
  padding: 15px 20px;
  .top {
    height: 40px;
    display: flex;
    align-items: center;
    .left {
      color: #222222;
      font-weight: 500;
      font-size: 18px;
      width: 15%;
    }
    .center {
      margin-left: 12%;
      width: 45%;
      ::v-deep .el-input__inner,
      .el-autocomplete,
      .el-input {
        border-radius: 50px;
        width: 100%;
      }
      .my-autocomplete {
        li {
          line-height: normal;
          padding: 7px;

          .name {
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .addr {
            font-size: 12px;
            color: #b4b4b4;
          }

          .highlighted .addr {
            color: #ddd;
          }
        }
      }
    }
    .right {
      width: 28%;
    }
  }
}
</style>
